import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { EssentialMetrics } from './EssentialMetrics';
import { ProductOverview } from './ProductOverview';
import { AIAssistant } from './AIAssistant';
export function Dashboard() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-83">
      <Sidebar data-id="element-84" />
      <div className="pl-64 transition-all duration-300 ease-in-out" data-id="element-85">
        <Header title="Dashboard" subtitle="Monitor your products, claims, and supplier compliance" data-id="element-86" />
        <main className="p-8" data-id="element-87">
          <AIAssistant data-id="element-88" />
          <div className="bg-white rounded-lg border p-4 mb-6" data-id="element-89">
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-90">
              <div className="flex-1 relative" data-id="element-91">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" data-id="element-92" />
                <input type="text" placeholder="Search products or brands..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-93" />
              </div>
              <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-94">
                <option value="all" data-id="element-95">All Products</option>
                <option value="issues" data-id="element-96">🔴 Issues Found</option>
                <option value="review" data-id="element-97">🟡 Under Review</option>
                <option value="compliant" data-id="element-98">🟢 Compliant</option>
              </select>
            </div>
          </div>
          <ProductOverview searchQuery={searchQuery} filterStatus={filterStatus} data-id="element-99" />
        </main>
      </div>
    </div>;
}